import VueDragUploader from '../components/vue-drag-uploader/uploader';

window.VueDragUploader = VueDragUploader;
